import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class DeleteCardService {
  constructor(private http: HttpClient) {}

  deleteCard(cardId: number) {
    return this.http.delete(`${environment.apiUrl}/v1/main/user/cards/${cardId}`, GlobalConstants.headers)
  }

  setAsDefaultCreditCardService(cardId: number) {
    return this.http.patch(`${environment.apiUrl}/v1/main/user/cards/${cardId}`, {} ,GlobalConstants.headers)
  }
}
